import styled from "styled-components";

export const Container = styled.div`
    /* .next-step-modal { */
        /* margin: 20px; */
        .header {
        padding-bottom: 15px;
        h3 {
            padding: 14px 20px 0 24px !important;
            margin: 0;
            color: #0a223a;
            font-weight: bold;
            text-align: center;
            font-size: 18px;
        }
        button {
            background: transparent;
            position: absolute;
            right: 4px;
            top: 4px;
            height: 42px;
            cursor: pointer;
            .closeIcon {
                width: 22px;
            }
        }
        }
        .modal-body {
        padding: 0 24px;
    
        h3 {
            margin: 0;
        }
    
        p {
            color: #191819;
            font-size: 16px;
            line-height: 1.4;
        }
        h5 {
        color: #191819;
        font-size: 14px;
        line-height: 1.4;
        margin-bottom: 10px;
        font-weight: bold;
        }
        }
    
        .modal-title {
        font-weight: 800;
        text-transform: uppercase;
        color: $primary-text;
        font-size: 12px !important;
        text-align: center;
        line-height: 22px;
        }
        .modal-footer {
        padding-top: 0;
        border-top: none;
        justify-content: center;
        button {
            width: 104px !important;
            height: 36px;
        }
        .app-green-button {
            background-color: $purple;
        }
        }
    
        .modal-content {
        max-height: calc(80vh - 152px);
        overflow: auto;
        color: $primary-text;
        font-size: 1.125rem;
        text-align: center;
        border: none !important;
        }
    
        .app-green-button {
        border: none;
        &:hover,
        &:active,
        &:focus {
            border: none;
        }
        }
    /* } */
    
    .alert-modal {
        label {
        font-size: 1.2rem;
        cursor: pointer;
        }
        button {
        height: 48px;
        }
    }
    
    @media screen and (min-width: 1024px) {
        .next-step-modal {
        margin: auto;
    
        .modal-footer {
            button {
            width: 104px;
            }
        }
        }
    }
`;